import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "./helpers/withSetPropAction";
import { Address, Country, Language, Currency } from "@/apis/address/address.interface";

/**
 * 国家数据 Store 模型
 * 用于管理国家、地址、语言、货币等全局数据
 */
export const CountryStoreModel = types
  .model("CountryStore")
  .props({
    // 当前国家信息
    currentCountryData: types.frozen<Country | null>(null),
    // 当前国家code
    currentCountryCode: types.optional(types.string, ""),
    // 国家列表
    countryList: types.frozen<Country[]>([]),
    // 当前地址信息
    currentAddress: types.frozen<Address | null>(null),
    // 支持的语言列表
    supportLanguageList: types.frozen<Language[]>([]),
    // 支持的货币列表
    supportCurrencyList: types.frozen<Currency[]>([]),
    // 当前语言
    currentLanguageCode: types.optional(types.string, ""),
    // 当前语言信息
    currentLanguageData: types.frozen<Language | null>(null),
    // 当前货币
    currentCurrencyCode: types.optional(types.string, ""),
    // 当前货币信息
    currentCurrencyData: types.frozen<Currency | null>(null),
    // 数据是否已初始化
    // isInitialized: types.optional(types.boolean, false)
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    /**
     * 初始化国家数据
     */
    initCountryData(data: {
      currentCountryData: Country | null;
      currentCountryCode: string;
      countryList: Country[];
      currentAddress: Address | null;
      supportLanguageList: Language[];
      supportCurrencyList: Currency[];
      currentLanguageCode: string;
      currentLanguageData: Language;
      currentCurrencyCode: string;
      currentCurrencyData: Currency;
    }) {
      self.currentCountryData = data.currentCountryData;
      self.currentCountryCode = data.currentCountryCode;
      self.countryList = data.countryList;
      self.currentAddress = data.currentAddress;
      self.supportLanguageList = data.supportLanguageList;
      self.supportCurrencyList = data.supportCurrencyList;
      self.currentLanguageCode = data.currentLanguageCode;
      self.currentLanguageData = data.currentLanguageData;
      self.currentCurrencyCode = data.currentCurrencyCode;
      self.currentCurrencyData = data.currentCurrencyData;
      // self.isInitialized = true;
    },

    /**
     * 更新当前国家
     */
    updateCurrentCountry(country: Country) {
      self.currentCountryData = country;
    },

    /**
     * 更新当前地址
     */
    updateCurrentAddress(address: Address) {
      self.currentAddress = address;
    },

    /**
     * 更新支持的语言列表
     */
    updateSupportLanguageList(languageList: Language[]) {
      self.supportLanguageList = languageList;
    },

    /**
     * 更新支持的货币列表
     */
    updateSupportCurrencyList(currencyList: Currency[]) {
      self.supportCurrencyList = currencyList;
    },

    /**
     * 更新当前语言
     */
    updateCurrentLanguage(language: Language) {
      self.currentLanguageCode = language.code;
      self.currentLanguageData = language;
    },

    /**
     * 更新当前货币
     */
    updateCurrentCurrency(currency: Currency) {
      self.currentCurrencyCode = currency.code;
      self.currentCurrencyData = currency;
    },

    /**
     * 重置数据
     */
    reset() {
      self.currentCountryData = null;
      self.currentCountryCode = "";
      self.countryList = [];
      self.currentAddress = null;
      self.supportLanguageList = [];
      self.supportCurrencyList = [];
      self.currentLanguageCode = "";
      self.currentLanguageData = null;
      self.currentCurrencyCode = "";
      self.currentCurrencyData = null;
      // self.isInitialized = false;
    }
  }));

export interface CountryStore extends Instance<typeof CountryStoreModel> {}
export interface CountryStoreSnapshot extends SnapshotIn<typeof CountryStoreModel> {}
